import { Injectable } from '@angular/core';
import { TextMessageTemplate } from 'models';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class TextMessageService {
	constructor(private http: HttpClient) {}

	public get(): Observable<TextMessageTemplate[]> {
		return this.http.get<TextMessageTemplate[]>('api/textmessagetemplate/get');
	}

	public getByUser(): Observable<TextMessageTemplate[]> {
		return this.http.get<TextMessageTemplate[]>('api/textmessagetemplate/getbyuser');
	}

	public getById(id: number): Observable<TextMessageTemplate> {
		return this.http.get<TextMessageTemplate>(`api/textmessagetemplate/get/${id}`);
	}

	public saveEnabledFlag(textMessageTemplate: TextMessageTemplate): Observable<TextMessageTemplate> {
		return this.http.put<TextMessageTemplate>('api/textmessagetemplate/saveenabledflag', textMessageTemplate);
	}

	public saveEnabledFlagByUser(textMessageTemplate: TextMessageTemplate): Observable<TextMessageTemplate> {
		return this.http.put<TextMessageTemplate>('api/textmessagetemplate/saveenabledflagbyuser', textMessageTemplate);
	}

	public edit(textMessageTemplate: TextMessageTemplate): Observable<TextMessageTemplate> {
		return this.http.put<TextMessageTemplate>('api/textmessagetemplate/edit', textMessageTemplate);
	}

	public override(textId: number): Observable<void> {
		return this.http.put<void>('api/textmessagetemplate/override', textId);
	}

	public delete(textId: number): Observable<void> {
		return this.http.put<void>('api/textmessagetemplate/delete', textId);
	}
}
